import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { ApiResultDialogComponent } from 'src/app/components/api-result-dialog/api-result-dialog.component';
import { BehaviorSubject } from 'rxjs';
import { InputDiscountDialogComponent } from 'src/app/components/input-discount-dialog/input-discount-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/shared/user.service';
import { MastersKeyStringValue } from './MastersKeyStringValue.service';
import { displayRateModel } from 'src/app/models/Accounting/tRateModel';
import { DisplayData } from 'src/app/models/non-master-model/DisplayData';
import { ApiResultV2DialogComponent } from 'src/app/components/api-result-v2-dialog/api-result-v2-dialog.component';
import { ApiMessageDialogComponent } from 'src/app/components/api-message-dialog/api-message-dialog.component';

var TAG = "ApiResultDialogService";

@Injectable({
    providedIn: 'root'
})
export class ApiResultDialogService {

    constructor(private log: LoggerService,
        private modalService: NgbModal,
        private translate: TranslateService,
        private userService: UserService,
    ) { }

    openSimpleDialog(action:string,msg: string){
      return this.openDialog(action,"","",msg);
    }

    openDialog(action: string, tableKeyValue: string, status: string, msg: string, options?:{isError:Boolean}) {
        // console.log('open Dialog');
        this.log.d(TAG, 'open Dialog ,action = ' + action +
        ' , tableKeyValue = ' + tableKeyValue + ' , msg = ' + msg);
        const modalRef = this.modalService.open(ApiResultDialogComponent, { centered: true, backdrop: 'static'});

        // const modalRef = this.modalService.open(ModelComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.action = action;
        modalRef.componentInstance.status = status;
        modalRef.componentInstance.tableKeyValue = tableKeyValue;
        modalRef.componentInstance.msg = msg;
        modalRef.componentInstance.options = options;

        // modalRef.componentInstance.displayMsg = this.getDisplayMsg(tableKeyValue);
        // modalRef.componentInstance.data = data;

        return modalRef;

    }

    openDialogV2(action: string, tableKeyValue: string, msg: string, displayData:DisplayData) {

      console.debug(`${TAG};; openDialogV2;; action = ${action} , tableKeyValue = ${tableKeyValue} , msg = ${msg} , displayData = ${JSON.stringify(displayData)}`);

      const modalRef = this.modalService.open(ApiResultV2DialogComponent, { centered: true, backdrop: 'static'});

      modalRef.componentInstance.action = action;
      modalRef.componentInstance.tableKeyValue = tableKeyValue;
      modalRef.componentInstance.msg = msg;
      modalRef.componentInstance.displayData = displayData;

      return modalRef;
    }

    openMessageDialog(action: string, tableKeyValue: string, status: string, msg: string, options?:{isError:Boolean}) {

      const modalRef = this.modalService.open(ApiMessageDialogComponent, { centered: true, backdrop: 'static'});

      modalRef.componentInstance.action = action;
      modalRef.componentInstance.status = status;
      modalRef.componentInstance.tableKeyValue = tableKeyValue;
      modalRef.componentInstance.msg = msg;
      modalRef.componentInstance.options = options;

      return modalRef;

    }



    InputDialog(itemCateName: string, itemDesc: string, PTypeDesc: string,standardPrice:number) {

        const modalRef = this.modalService.open(InputDiscountDialogComponent, { centered: true, backdrop: 'static'});

        // const modalRef = this.modalService.open(ModelComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.itemCateName = itemCateName;
        modalRef.componentInstance.itemDesc = itemDesc;
        modalRef.componentInstance.PTypeDesc = PTypeDesc;
        modalRef.componentInstance.standardPrice=standardPrice;

        // modalRef.componentInstance.displayMsg = this.getDisplayMsg(tableKeyValue);
        // modalRef.componentInstance.data = data;

        return modalRef;

    }

    CheckUnauthorizedReason(token:string){

        this.userService.GetUnauthorizedReason(token).subscribe(
            (data: any) => {
                var dataModel = JSON.stringify(data.unauthorizedReason);
                this.log.i(TAG, 'GetUnauthorizedReason data = ' + data.unauthorizedReason);
                //var msg = dataModel.;
                if( this.modalService.hasOpenModals()){
                    this.modalService.dismissAll();
                    this.openDialog(MastersKeyStringValue.ACTION_MessageDialog, '', MastersKeyStringValue.STATUS_SUCCESS, data.unauthorizedReason);
                }

            }
          );


    }

    CheckApiResultDialogOpen(){
        return this.modalService.hasOpenModals();
    }

    GetErrorMsg(errCode:number){
        var returnDisplayMsg : string = "" ;
        if (errCode === 401) {
         this.translate.get('Message_ForceLogout').subscribe((res: string) => {
             returnDisplayMsg = res;
            // this.removeToken();
         });
         } else if (errCode === 0) {
             this.translate.get('Message_ForceLogout_exception').subscribe((res: string) => {
                 returnDisplayMsg = res;
             });
         }else {
             returnDisplayMsg = "失敗"+"<br>請重試/聯絡系統職員<br>"+"Error Code : "+errCode;
         }


         return returnDisplayMsg;
     }
}
